export function updateImpersonateUserToken(token) {
  let user = JSON.parse(localStorage.getItem('user')) || {}
  user.token = token
  user.impersonated = true
  localStorage.setItem('user', JSON.stringify(user))
}